// extracted by mini-css-extract-plugin
export default {"connect":"connect_vfT75","connectWrapper":"connectWrapper_jO00k"};